var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('NavBar'),_c('SideBar'),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_c('aside',{staticClass:"control-sidebar control-sidebar-dark"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }